import { Button, Form, Input, Select, message } from 'antd';
import { useEffect, useState } from 'react';
import { serverFetch } from '@server';
import { showError } from '@extensions/utils';

const MODELS = [
    { value: 'yandexgpt-lite', label: 'YandexGPT Lite' },
    { value: 'yandexgpt', label: 'YandexGPT' },
];

// Ключи расшифровки и YandexGPT фирмы. Способ расшифровки: локальный сервис, SpeechKit или cloud.ru.
const AiSettings = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [testingSpeech, setTestingSpeech] = useState(false);
    const [testingLlm, setTestingLlm] = useState(false);
    const [localSpeechAvailable, setLocalSpeechAvailable] = useState(true);
    const speechProvider = Form.useWatch('speechProvider', form);

    useEffect(() => {
        setLoading(true);
        serverFetch('aisettings')
            .then((item) => {
                setLocalSpeechAvailable(item.localSpeechAvailable !== false);
                form.setFieldsValue({
                    speechProvider: item.speechProvider || 'local',
                    speechApiKey: item.speechApiKey ?? '',
                    cloudRuApiKey: item.cloudRuApiKey ?? '',
                    llmApiKey: item.llmApiKey ?? '',
                    llmFolderId: item.llmFolderId ?? '',
                    llmModel: item.llmModel || 'yandexgpt-lite',
                });
            })
            .catch(showError)
            .finally(() => setLoading(false));
    }, [form]);

    const save = () => {
        form.validateFields().then((values) => {
            setSaving(true);
            serverFetch('aisettings', { method: 'PUT', bodyData: values })
                .then((item) => {
                    form.setFieldsValue(item);
                    message.success('Сохранено');
                })
                .catch(showError)
                .finally(() => setSaving(false));
        }).catch(() => {});
    };

    const testSpeech = () => {
        setTestingSpeech(true);
        serverFetch('aisettings/test-speech', { method: 'POST', bodyData: form.getFieldsValue() })
            .then((result) => message.success(result.message))
            .catch(showError)
            .finally(() => setTestingSpeech(false));
    };

    const testLlm = () => {
        setTestingLlm(true);
        serverFetch('aisettings/test-llm', { method: 'POST', bodyData: form.getFieldsValue() })
            .then((result) => message.success(result.message))
            .catch(showError)
            .finally(() => setTestingLlm(false));
    };

    return (
        <Form form={form} layout="vertical" className="settings-form" disabled={loading}>
            <h3>Расшифровка речи</h3>
            <Form.Item name="speechProvider" label="Способ расшифровки">
                <Select
                    options={[
                        { value: 'local', label: `Локальный сервис (настроен на сервере)${localSpeechAvailable ? '' : ' — не настроен'}`, disabled: !localSpeechAvailable },
                        { value: 'yandex', label: 'Yandex SpeechKit' },
                        { value: 'cloudru', label: 'cloud.ru (Whisper large v3)' },
                    ]}
                />
            </Form.Item>
            {speechProvider === 'yandex' && (
                <Form.Item
                    name="speechApiKey"
                    label="API-ключ Yandex SpeechKit"
                    rules={[{ required: true, message: 'Укажите API-ключ Yandex SpeechKit' }]}
                >
                    <Input.Password autoComplete="new-password" />
                </Form.Item>
            )}
            {speechProvider === 'cloudru' && (
                <Form.Item
                    name="cloudRuApiKey"
                    label="API-ключ cloud.ru"
                    rules={[{ required: true, message: 'Укажите API-ключ cloud.ru' }]}
                >
                    <Input.Password autoComplete="new-password" />
                </Form.Item>
            )}
            {speechProvider === 'local' && (
                <div className="card-list-muted" style={{ marginBottom: 16 }}>
                    Ключ не нужен: расшифровку выполняет сервис, указанный в конфигурации сервера.
                </div>
            )}
            <Button loading={testingSpeech} onClick={testSpeech} style={{ marginBottom: 24 }}>
                Проверить расшифровку
            </Button>

            <h3>LLM</h3>
            <Form.Item name="llmApiKey" label="API-ключ YandexGPT">
                <Input.Password autoComplete="new-password" />
            </Form.Item>
            <Form.Item name="llmFolderId" label="Идентификатор каталога">
                <Input autoComplete="off" />
            </Form.Item>
            <Form.Item name="llmModel" label="Модель" initialValue="yandexgpt-lite">
                <Select options={MODELS} />
            </Form.Item>
            <Button loading={testingLlm} onClick={testLlm} style={{ marginBottom: 24 }}>
                Проверить соединение с LLM
            </Button>

            <div>
                <Button type="primary" loading={saving} onClick={save}>Сохранить</Button>
            </div>
        </Form>
    );
};

export default AiSettings;
